module.exports = __webpack_public_path__ + "static/img/kefu.f9f1e5da.png";